import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authslice from "../slice/auth/authslice";
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // List of reducers to persist
};

const reducers = combineReducers({
  auth: authslice,
});
const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  // Add any other middleware here
});

export const persistor = persistStore(store);

export default store;
